// extracted by mini-css-extract-plugin
export default {"button":"_2QXXy","clickableArea":"_38Zqt","icon":"_2KfuU","facebook":"_2g7sV","twitter":"OFWTj","linked-in":"-FE00","linkedIn":"-FE00"};